import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { MessageBox } from "uiv";

@Component
export default class RawNodeEditor extends Vue {

    @Prop()
    value: string;

    @Prop()
    nodePathAndName: string;


    @Watch("nodePathAndName")
    valueChanged(newVal) {
        if (newVal)
            this.refreshData();
    }

    isVisible: boolean = false;

    rawValue: string = "";

    beforeRouteLeave(to, from, next) {
        this.isVisible = false;
        next();
    }

    refreshData() {


        if (this.value && this.nodePathAndName)
            FetchWrapper.fetch(`/api/1.0/query/GetNodeDataBlock?modelId=${this.value}&nodePathAndName=${this.nodePathAndName}`,
                { method: "get" })
                .then(response => response.json())
                .then(response => this.rawValue = JSON.stringify(response, null, 4));

    }

    mounted() {
        this.isVisible  = true;
        this.refreshData();
    }

    saveButtonClick() {

        MessageBox.confirm({
            title: `Raw Node Editor`,
            content: `Save changes to ${this.nodePathAndName}?<p><p> Warning: this can cause data corruption if used incorrectly.`,
            html: true
        })
            .then(ok => {
                if (ok) {
                    var payload =
                    {
                        modelId: this.value,
                        nodePathAndName: this.nodePathAndName,
                        nodeJson: this.rawValue
                    };
                    var body = JSON.stringify(payload);

                    FetchWrapper.sendCommandAndHandle("/api/1.0/command/SetNodeFromJsonCommand",
                        {
                            method: "post", body: body
                        });
                }
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/raw-node-editor/raw-node-editor.ts